export const STARTED = 'STARTED';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';
export const UNINITIALIZED = 'UNINITIALIZED';
export default {
  STARTED,
  SUCCEEDED,
  FAILED,
  UNINITIALIZED
};